import { Link } from "react-router-dom";
import { H5, SVG } from "../../../AbstractElements";
 
 const organizationPaymentsBodyData = [
  {
    color: "primary",
    icon: "send",
    title: "Payment from Tech Corp Inc.",
    date: "2025-07-22, 3:45 PM",
    status: "Completed",
    amount: "+ $900.00",
    users: 150,
  },
  {
    color: "secondary",
    icon: "work",
    title: "Invoice to Health Sync Ltd.",
    date: "2025-07-20, 1:10 PM",
    status: "Pending",
    amount: "+ $850.00",
    users: 85,
  },
  {
    color: "success",
    icon: "graph",
    title: "Payment from Edu Future Org.",
    date: "2025-07-19, 11:45 AM",
    status: "Verified",
    amount: "+ $500.00",
    users: 30,
  },
  {
    color: "danger",
    icon: "bookmark",
    title: "Refund to Green Energy Co.",
    date: "2025-07-23, 12:00 PM",
    status: "Rejected",
    amount: "- $300.00",
    users: 200,
  },
  {
    color: "info",
    icon: "send",
    title: "Payment from Finance Pro Solutions",
    date: "2025-07-21, 9:30 AM",
    status: "Completed",
    amount: "+ $700.00",
    users: 120,
  },
  {
    color: "warning",
    icon: "work",
    title: "Invoice to Retail Max Corp.",
    date: "2025-07-19, 2:15 PM",
    status: "Pending",
    amount: "+ $650.00",
    users: 75,
  },
  {
    color: "success",
    icon: "graph",
    title: "Payment from Tech Startup Inc.",
    date: "2025-07-17, 10:00 AM",
    status: "Completed",
    amount: "+ $400.00",
    users: 45,
  },
  {
    color: "danger",
    icon: "bookmark",
    title: "Refund to Global Trade Ltd.",
    date: "2025-07-16, 4:00 PM",
    status: "Rejected",
    amount: "- $200.00",
    users: 180,
  },
  {
    color: "primary",
    icon: "send",
    title: "Payment from Innovation Hub Co.",
    date: "2025-07-15, 8:30 AM",
    status: "Completed",
    amount: "+ $550.00",
    users: 95,
  },
];

const OrganizationPaymentsBody = ({ showCount = 4 }) => {
  return (
    <>
      {organizationPaymentsBodyData.slice(0, showCount).map((data, i) => (
        <tr key={i}>
          <td>
            <div className="d-flex">
              <span className={`bg-light-${data.color} history d-flex align-items-center justify-content-center rounded-circle`} style={{ width: 32, height: 32 }}>
                <SVG iconId={data.icon} style={{ width: 18, height: 18 }} />
              </span>
              <div className="flex-grow-1 ms-2">
                <Link to={`${process.env.PUBLIC_URL}/payments/details`}>
                  <span>{data.title}</span>
                  <H5>{data.date}</H5>
                </Link>
                <small className="text-muted">Users: {data.users || "N/A"}</small>
              </div>
            </div>
          </td>
          <td>{data.status}</td>
          <td>{data.amount}</td>
        </tr>
      ))}
    </>
  );
};

export default OrganizationPaymentsBody;